import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=10412f54&scoped=true&"
import script from "./Mobile.vue?vue&type=script&lang=js&"
export * from "./Mobile.vue?vue&type=script&lang=js&"
import style0 from "./Mobile.vue?vue&type=style&index=0&id=10412f54&prod&lang=css&"
import style1 from "./Mobile.vue?vue&type=style&index=1&id=10412f54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10412f54",
  null
  
)

export default component.exports